import React from 'react'
import PropTypes from 'prop-types'
import './countriesList.scss'

const CountriesList = props => {
    const countriesListOne = props.countriesData.countriesListOne;
    const countriesListTwo = props.countriesData.countriesListTwo;
    return (
        <div className="f-list-items">
            <ul className="f-countries-column">
                { countriesListOne.map((item) =>(
                    item.titulo === props.countriesData.currentCountry ?
                    <li className="f-nav-link-country f-nav-link-country-selected" key={item.id}><a href={item.dominio}><span className="f-selected-option"></span>{item.titulo}</a></li>
                    : <li className="f-nav-link-country" key={item.id}><a href={item.dominio}>{item.titulo}</a></li>
                ))}
            </ul>
            <ul className="f-countries-column">
                { countriesListTwo.map((item) =>(
                    item.titulo === props.countriesData.currentCountry ?
                    <li className="f-nav-link-country f-nav-link-country-selected" key={item.id}><a href={item.dominio}><span className="f-selected-option"></span>{item.titulo}</a></li>
                    : <li className="f-nav-link-country" key={item.id}><a target={item.titulo === 'OTROS PAÍSES' ? '_blank' : '' } href={item.dominio}>{item.titulo}</a></li>
                ))}
            </ul>
        </div>
        
    )
};

CountriesList.propTypes = {
    countriesList: PropTypes.array,
    fCloseClass: PropTypes.string
};

export default CountriesList
